import { RepoLoader } from "../../../components/RepoLoader";

export default function PRAnalysisIndexPage(): JSX.Element {
  return <RepoLoader />;
}
